import { fontsReady } from '../helpers/utils/fontsReady';

/** The board's code, split from Home's. */
export const loadCalculator = () => import('./SpadesCalculator');

/** Faces the board paints with. Home's are preloaded from index.html; the
 *  600 face is the board's own (fonts-board.css). */
const BOARD_FACES = [
  '400 1em Anton',
  '500 1em Poppins',
  '600 1em "Roboto Condensed"',
  '700 1em "Roboto Condensed"',
  '800 1em "Roboto Condensed"',
];

// Not a `?url` import: in dev that's a module request named after the font,
// on Home's first load. Vite rewrites this to the built asset's URL.
const boardFontUrl = new URL(
  '../assets/fonts/roboto-condensed-latin-600-normal.woff2',
  import.meta.url,
).href;

function preloadBoardFont() {
  if (document.querySelector(`link[rel="preload"][href="${boardFontUrl}"]`))
    return;
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'font';
  link.type = 'font/woff2';
  link.crossOrigin = '';
  link.href = boardFontUrl;
  document.head.appendChild(link);
}

/**
 * The board's route (React Router `lazy`). The router loads it before it
 * leaves Home, so Home stays up until the board can replace it, with no
 * blank page and no Suspense fallback (React holds a shown fallback for
 * 300ms). On a cold load, when nothing is on screen yet, it also waits
 * briefly for the board's fonts, so the scores don't paint in a fallback
 * face and reflow when the real one arrives. Coming from Home, Home's faces
 * are in already, and the tap shouldn't wait on the 600 face.
 */
export async function loadCalculatorRoute() {
  const coldLoad = !document.getElementById('root')?.hasChildNodes();
  preloadBoardFont();
  const { default: Component } = await loadCalculator();
  if (coldLoad) await fontsReady(BOARD_FACES);
  return { Component };
}

/**
 * Fetches the board's code once Home is idle, so Start and Continue don't
 * wait for it. Fonts are left to the route: Home must not download the 600
 * face.
 */
export function preloadCalculatorWhenIdle(): () => void {
  const preload = () => void loadCalculator().catch(() => undefined);
  if (typeof window.requestIdleCallback === 'function') {
    const id = window.requestIdleCallback(preload, { timeout: 2000 });
    return () => window.cancelIdleCallback(id);
  }
  const id = window.setTimeout(preload, 1000);
  return () => window.clearTimeout(id);
}
